import * as cms from '../../common/api/cms';

export const FETCH_POI = 'FETCH_POI';
export const FETCH_POI_SUCCESS = 'FETCH_POI_SUCCESS';
export const FETCH_POI_FAILURE = 'FETCH_POI_FAILURE';


export const fetchPointOfInterest = (coordinates, fetch = true) => async (dispatch) => {
  dispatch({ type: FETCH_POI });

  try {
    const poi = fetch ? await cms.fetchPointOfInterest(coordinates) : {};
    dispatch({
      type: FETCH_POI_SUCCESS,
      poi,
    });
  } catch (err) {
    dispatch({
      type: FETCH_POI_FAILURE,
      error: err,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/cms/poi.js